export default class Util {
	static isiOS() {
		let ua = navigator.userAgent;
		let isiPad = ua.indexOf('iPad') > -1 || (ua.indexOf('Macintosh') > -1 && 'ontouchend' in document);
		
		return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || isiPad;
	}
	
	static onWindowResize(callback) {
		if (Util.isiOS()) {
			setTimeout(() => {
				let app = document.getElementsByClassName('application--wrap')[0];
				app.style.minHeight = window.innerHeight + 'px';
				if (callback !== undefined)
					callback();
			}, 800);
		} else {
			if (callback !== undefined)
				callback();
		}
	}
	
	static array_remove(array, item, equation){
		if (equation === undefined)
			equation = (a, b) => { return a === b };
		let ret = null;
		array.some((v, i) => {
			if (equation(v, item)) {
				array.splice(i, 1);
				ret = item;
			}
		});
		return ret;
	}
	
	static arrayMoveTo (array, a, b){
		let index_a = array.indexOf(a);
		let index_b = array.indexOf(b);
		if(index_a < 0 || index_b < 0){
			return false;
		}
		if (index_a < index_b) {
			this._arrayMoveTo(array, index_a, index_b, false);
		} else {
			this._arrayMoveTo(array, index_a, index_b, true);
		}
		return true;
	}
	
	static arrayMoveToTop (array, a){
		let index_a = array.indexOf(a);
		if(index_a < 0){
			return false;
		}
		this._arrayMoveTo(array, index_a, 0, false);
		
		return true;
	}

	static _arrayMoveTo(array, src, dest, next){
		let offset = next ? 1: 0;

		if ( src === dest)
			return;

		let src_obj = array[src];
		this.array_remove (array, src_obj);
		array.splice(dest + offset, 0, src_obj);
	return true; 
	}
	
	static isPositionLast (array, a){
		if ( array === undefined | a === undefined)
			return;
		if (a === array[array.length - 1]){
			return true;
		} else {
			return false;
		}
	}
	
	static getDiffDay(basedate, currentdate){
		let day = basedate.getTime() - currentdate.getTime();
		return Math.floor(day / (1000*60*60*24));
	}

	static getDiffMinutes (basedate, currentdate){
		let minutes = basedate.getTime() - currentdate.getTime();
		return Math.floor(minutes / (1000 * 60));
	}

	static isValidCharPassword(value) {
		return !!value.match(/^[0-9a-zA-Z!-/:-@?[-`{-~]+$/);
	}
	
	static replaceEscapeString(str) {
		return new RegExp(str.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'));
	}
}
